<div
  class="top-bar-categories flex align-items-center mb-3"
  [class.p-0]="innerWidth < 450"
  [class.ps-4]="innerWidth < 450"
  (window:resize)="onResize($event)"
>
  <div class="title flex align-items-center me-auto">
    <i _ngcontent-serverapp-c11="" class="fas fa-truck-moving me-3"></i>
    <h5>Seguimiento de pedidos</h5>
  </div>
</div>

<div class="dashboard row m-0">
  <div class="col-lg-12 mb-3">
    <div class="card pt-0">
      <div style="margin-top: 10px">
        <app-trakingb2c
          *ngIf="['temp', 'b2c'].includes(usuario?.userRole || '')"
          [OV]="OV || ''"
        ></app-trakingb2c>
        <app-page-tracking-ov
          *ngIf="
            usuario?.userRole &&
            !['temp', 'b2c'].includes(usuario?.userRole || '')
          "
        ></app-page-tracking-ov>
      </div>
    </div>
  </div>
</div>
